import React from "react";
import "./faq.module.scss";
import { homeFaqs } from "../../../helpers/faqs";

export default function Faq() {
  return (
    <div className="faq-container px-0 w-75 container">
      <h2 className="text-center mb-4">
        <span>✨</span> Frequently Asked Questions <span>✨</span>
      </h2>

      <div className="accordion" id="faqAccordion">
        {homeFaqs.map((faq, index) => (
          <div className=" mb-1" key={index}>
            <h2 className="accordion-header" id={`heading-faq-${index}`}>
              <button
                className="accordion-button rounded-3 collapsed bg-secondary text-light"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-faq-${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {faq.question}
              </button>
            </h2>
            <div
              id={`collapse-faq-${index}`}
              className="accordion-collapse collapse rounded-bottom-3"
              aria-labelledby={`heading${index}`}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body bg-secondary text-light">
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
